import { create } from "zustand"

type ThemeStore = {
    theme: "light" | "dark"
}

export const useThemeStore = create<ThemeStore>((set, get) => ({
    theme: window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}))